import type { ReactNode } from "react";
import { useTranslate } from "ra-core";
import { Notification } from "@/components/admin/notification";
import { cn } from "@/lib/utils";
import { AppMark, panelClass } from "../palmtree/shell";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const authInputClassName = "h-11 rounded-full px-4";
export const authButtonClassName = "h-11 w-full cursor-pointer rounded-full";

export const AuthShell = ({ children }: { children: ReactNode }) => {
  const { title } = useConfigurationContext();
  const translate = useTranslate();
  const brand = title?.includes("Hub") ? title : "PalmTree Hub";

  return (
    <div className="flex min-h-svh items-center justify-center bg-gradient-to-b from-accent-soft via-background to-secondary-soft px-4 py-8">
      <div className="w-full max-w-[400px]">
        <div className="mb-5 flex items-center justify-center gap-2.5">
          <AppMark className="size-11 rounded-[12px] text-[11px]" />
          <h1 className="font-heading text-xl font-extrabold tracking-tight">
            {brand}
          </h1>
        </div>
        <div
          className={cn(
            panelClass,
            "rounded-[24px] p-8 [&_[data-slot=form-label]_span[aria-hidden=true]]:hidden",
          )}
        >
          {children}
        </div>
        <p className="mt-5 text-center text-[11px] text-muted-foreground">
          {brand} ·{" "}
          {translate("crm.auth.secure_access", { _: "secure access" })}
        </p>
      </div>
      <Notification />
    </div>
  );
};
